import { QueryLazyOptions } from "@apollo/client";
import exclamationModal from "@assets/images/exclamationModal.svg";
import { Button, Grid } from "@material-ui/core";
import FormField from "@saleor/components/FormField/FormField";
import MyTypography from "@saleor/components/MyTypography";
import SingleTextField from "@saleor/components/SingleTextField";
import ModalAddress from "@saleor/createOrChangeNotRefContract/components/ModalAddress/ModalAddress";
import ModalAddressOneTime from "@saleor/createOrChangeNotRefContract/components/ModalAddress/ModalAddressOneTime";
import ModalAddressUnloading from "@saleor/createOrChangeNotRefContract/components/ModalAddress/ModalAddressUnloading";
import ModalOneTimeForms from "@saleor/createOrChangeNotRefContract/components/ModalAddress/ModalOneTimeForms";
import ModalCreditMasterNotRef from "@saleor/createOrChangeNotRefContract/components/ModalCreditMasterNotRef";
import { getNotRefCreateOrderPath } from "@saleor/createOrChangeNotRefContract/urls";
import {
  clearLocalOrderIds,
  getLocalOrderId,
  INIT_EMPTY_ORDERLINE
} from "@saleor/createOrChangeNotRefContract/utils";
import {
  Exact,
  useGetCreditLimitLazyQuery,
  useGetCustomerBlockLazyQuery,
  useSearchSuggestionSoldTosCipLazyQuery,
  useShipToUnloadingAndTaxLazyQuery,
  useSoldToHeaderInfoCipLazyQuery
} from "@saleor/graphql";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import CreditCardIcon from "@saleor/icons/CreditCard";
import { mapEdgesToItems } from "@saleor/utils/maps";
import classNames from "classnames";
import { FormikProps } from "formik";
import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";

import DialogCreditBlock from "../../../DialogCreditBlock/DialogCreditBlock";
import DialogCustomerBlock from "../../../DialogCustomerBlock/DialogCustomerBlock";
import SoldToInputSuggestion from "../../../SoldToInputSuggestion";
import useStyles from "./styles";
import useNotRefPartner from "./useNotRefPartner";
import useNotRefSales from "./useNotRefSales";

export interface NotRefSalesPartnerFormProps {
  handleChangeNotRefSales?: any;
  handleChangeNotRefPartner?: any;
  formik: FormikProps<any>;
  showDetails?: boolean;
  handleShowDetails?: any;
  handleSalesOrg?: any;
  handleSoldTo?: any;
  fetchOrderData?: (
    options?: QueryLazyOptions<
      Exact<{
        orderId: string;
      }>
    >
  ) => void;
  shouldRecheckBlock?: boolean;
  orderId: string;
  formikOneTimeCust?: FormikProps<any>;
  onApplyAll: () => void;
  isChangeFlow?: boolean;
  isViewMode?: boolean;
  formikItemDetails: FormikProps<any>;
  saleOrgLoading?: boolean;
  salesDataloadingCompleted?: boolean;
}

const NotRefSalesPartnerForm: React.FC<NotRefSalesPartnerFormProps> = props => {
  const {
    formik,
    showDetails,
    handleShowDetails,
    handleSalesOrg,
    handleSoldTo,
    fetchOrderData,
    shouldRecheckBlock,
    orderId,
    onApplyAll,
    isChangeFlow,
    isViewMode,
    formikItemDetails,
    saleOrgLoading,
    salesDataloadingCompleted
  } = props;

  const notify = useNotifier();
  const [newSoldToCode, setNewSoldToCode] = useState("");
  const [loadHeaderData, setLoadHeaderData] = useState<boolean>(false);
  const [openModalCreditBlock, setOpenModalCreditBlock] = useState<boolean>(
    false
  );
  const [openModalCustomerBlock, setOpenModalCustomerBlock] = useState<boolean>(
    false
  );
  const isOneTimeCustomer = formik?.values?.isOneTimeCustomer;
  const { formSalesData, salesOrganizationList } = useNotRefSales(
    showDetails,
    formik,
    formik?.values?.salesGroupList,
    isChangeFlow,
    isViewMode,
    salesDataloadingCompleted
  );
  const { formPartnerData } = useNotRefPartner(
    showDetails,
    formik.values?.paymentTermList,
    formik,
    isChangeFlow,
    isViewMode
  );
  const [billToVisible, setBillToVisible] = useState(false);
  const [shipToVisible, setShipToVisible] = useState(false);
  const [soldToVisible, setSoldToVisible] = useState(false);
  const [visibless, setVisibless] = useState(false);
  const [visibles, setVisibles] = useState(false);
  const classes = useStyles();
  const [modalOneTimeFormVisible, setModalOneTimeFormVisible] = useState(false);
  const [formType, setFormType] = useState("");
  const [opts, setOpts] = useState<any[]>([]);

  // Handle is not function
  const safeHandleShowDetails = handleShowDetails || (() => null);
  const safeHandleSoldTo = handleSoldTo || (() => null);

  const navigate = useNavigator();
  const intl = useIntl();

  const toggleModalCreditBlock = () => {
    setOpenModalCreditBlock(val => !val);
  };
  const toggleModalCustomerBlock = () => {
    setOpenModalCustomerBlock(val => !val);
  };
  const handleVisible = addressType => {
    if (addressType === "billTo") {
      if (isOneTimeCustomer) {
        setModalOneTimeFormVisible(true);
      } else {
        setBillToVisible(true);
      }
      setFormType("billTo");
    } else if (addressType === "shipTo") {
      if (isOneTimeCustomer) {
        setModalOneTimeFormVisible(true);
      } else {
        setShipToVisible(true);
      }
      setFormType("shipTo");
    } else if (addressType === "soldToAddress") {
      if (isOneTimeCustomer) {
        setModalOneTimeFormVisible(true);
      } else {
        setSoldToVisible(true);
      }
      setFormType("soldToAddress");
    }
  };

  const handleVisibles = () => {
    setVisibles(true);
  };
  const handleV = addressType => {
    if (addressType === "soldTo") {
      setVisibless(true);
      setFormType("soldTo");
    } else {
      setVisibless(true);
    }
  };
  const [getCreditBlock] = useGetCreditLimitLazyQuery({
    fetchPolicy: "no-cache",
    onCompleted: data => {
      const creditStatus = data?.getCreditLimit?.creditBlockStatus;
      if (creditStatus) {
        toggleModalCreditBlock();
        setLoadHeaderData(false);
      } else if (!openModalCustomerBlock) {
        setLoadHeaderData(true);
      }
    },
    onError: error => {
      notify({
        status: "error",
        apiMessage: error.message
      });
    }
  });
  const [callShipToUnloadingAndTax] = useShipToUnloadingAndTaxLazyQuery({
    variables: {
      shipTo: formik?.values?.shipTo?.split("-")?.[0]?.trim(),
      saleOrg: formik?.values?.salesOrganizationCode,
      distributionChannel: formik?.values?.distributionChannelCode,
      division: formik?.values?.divisionCode
    },
    onCompleted: data => {
      formik.setValues(prev => ({
        ...prev,
        unloadingPoints: data?.shipToUnloadingAndTax?.unloadingPoints,
        unloadingPoint:
          data?.shipToUnloadingAndTax?.defaultUnloadingPoint?.unloadingPoint ??
          "",
        taxClass: data?.shipToUnloadingAndTax?.taxClassification
      }));
    }
  });

  const [getCustomerBlock] = useGetCustomerBlockLazyQuery({
    fetchPolicy: "no-cache",
    onCompleted: data => {
      if (data?.getCustomerBlock?.customerBlock) {
        toggleModalCustomerBlock();
        setLoadHeaderData(false);
      }
    }
  });
  const [headerData] = useSoldToHeaderInfoCipLazyQuery({
    fetchPolicy: "no-cache",
    onCompleted: data => {
      const headerData = data?.soldToHeaderInfoCip;
      safeHandleSoldTo(
        headerData?.soldTo?.code + " - " + headerData?.soldTo?.name
      );
      formik.setValues({
        ...formik.values,
        soldToCode: headerData?.soldTo?.code ?? "",
        soldToDisplayText: headerData?.soldTo?.displayText ?? "",
        billTo: headerData?.defaultBillTo
          ? headerData?.defaultBillTo?.code +
            " - " +
            headerData?.defaultBillTo?.name +
            " - " +
            headerData?.defaultBillTo?.addressText
          : "",
        shipTo: headerData?.defaultShipTo
          ? headerData?.defaultShipTo?.code +
            " - " +
            headerData?.defaultShipTo?.name +
            " - " +
            headerData?.defaultShipTo?.addressText
          : "",
        unloadingPoint: headerData?.defaultUnloadingPoint?.unloadingPoint ?? "",
        paymentTerm: headerData?.defaultPaymentTerm?.code ?? "",
        salesGroupCode: headerData?.defaultSaleGroup?.code ?? "",
        salesEmployee: headerData?.saleEmployee ?? "",
        salesOfficeCode: headerData?.saleOffice?.code ?? "",
        customerId: headerData?.soldTo?.id ?? "",
        taxClass: headerData?.taxClassification ?? "",
        orderType: headerData?.orderType ?? "",
        shipTolist: headerData?.shipTo ?? [],
        billTolist: headerData?.billTo ?? [],
        unloadingPoints: headerData?.unloadingPoints ?? [],
        paymentTermList: headerData?.paymentTerm ?? [],
        salesGroupList: headerData?.saleGroup ?? [],
        headerNote1: headerData?.headerNote1Th?.textLine ?? "",
        internalCommentsToWarehouse:
          headerData?.commentsToWarehouseTh?.textLine ?? "",
        cash: headerData?.orderType === "ZP20" ? "ชำระเงินแล้ว" : ""
      });
      safeHandleShowDetails(true);
      setLoadHeaderData(false);
    },
    onError: error => {
      notify({
        status: "error",
        apiMessage: error.message
      });
    }
  });
  const isDeliveryType = (status, allowedStatuses) =>
    allowedStatuses.includes(status);
  const deliveryTypeReqDate = isDeliveryType(formik?.values?.orderStatus, [
    "Completed Delivery",
    "Cancelled (93)"
  ]);
  const applyAllButtonDisable =
    isChangeFlow && !isViewMode && deliveryTypeReqDate;

  const [
    getDataSuggestionsDemostic,
    {
      data: fetchDataSuggestionsDemostic,
      loading: loadingDataSuggestionDemostic
    }
  ] = useSearchSuggestionSoldTosCipLazyQuery({
    fetchPolicy: "no-cache"
  });

  const [
    openModalCreditMasterNotRef,
    setOpenModalCreditMasterNotRef
  ] = useState<boolean>(false);

  useEffect(() => {
    setOpts(
      (
        mapEdgesToItems(
          fetchDataSuggestionsDemostic?.searchSuggestionSoldTosCip
        ) || []
      ).map(data => ({
        title: data.displayText,
        value: data.code
      }))
    );
  }, [loadingDataSuggestionDemostic]);

  useEffect(() => {
    if (loadHeaderData) {
      headerData({
        variables: {
          soldTo: newSoldToCode,
          saleOrg: formik.values?.salesOrganizationCode,
          distributionChannel: formik.values?.distributionChannelCode,
          division: formik.values?.divisionCode
        }
      });
    }
  }, [loadHeaderData]);

  const [
    callCreditLimit,
    { data: dataCreditLimit, loading: loadingCreditLimit }
  ] = useGetCreditLimitLazyQuery({
    fetchPolicy: "no-cache",
    onError: error => {
      notify({
        status: "error",
        apiMessage: error.message
      });
    },
    onCompleted: data => {
      if (data.getCreditLimit) {
        setOpenModalCreditMasterNotRef(true);
      }
    }
  });

  useEffect(() => {
    const salesOptions = formSalesData[1]?.options;

    if (salesOptions) {
      const selectedOption = salesOptions.find(
        option => option.value === formik?.values?.salesOrganizationCode
      );

      if (selectedOption) {
        handleSalesOrg(selectedOption.label);
      }
    }
  }, [formSalesData]);

  useEffect(() => {
    if (
      !isChangeFlow &&
      formik?.values?.orderType !== "ZP20" &&
      (formik?.values?.paymentTerm === "NT00" ||
        formik?.values?.paymentTerm === "AP00")
    ) {
      formik.setValues({
        ...formik.values,
        orderType: "ZP20",
        cash: (formik?.values?.cash + " ชำระเงินแล้ว").trimStart()
      });
    }
    if (
      !isChangeFlow &&
      formik?.values?.orderType === "ZP20" &&
      formik?.values?.paymentTerm !== "NT00" &&
      formik?.values?.paymentTerm !== "AP00"
    ) {
      let cash = formik?.values?.cash;
      if (formik?.values?.cash.includes("ชำระเงินแล้ว")) {
        cash = formik?.values?.cash?.replace("ชำระเงินแล้ว", "").trim();
      }
      formik.setValues({
        ...formik.values,
        orderType: "",
        cash
      });
    }
  }, [formik?.values?.paymentTerm]);

  useEffect(() => {
    if (
      formik?.values?.orderType === "ZP20" &&
      formik?.values?.paymentTerm !== "NT00" &&
      formik?.values?.paymentTerm !== "AP00" &&
      formik.values?.paymentTermList?.length
    ) {
      formik.setValues({
        ...formik.values,
        paymentTerm: "AP00",
        cash: (formik?.values?.cash + " ชำระเงินแล้ว").trimStart()
      });
    }
    if (
      formik?.values?.orderType !== "ZP20" &&
      (formik?.values?.paymentTerm === "NT00" ||
        formik?.values?.paymentTerm === "AP00")
    ) {
      let cash = formik?.values?.cash;
      if (formik?.values?.cash.includes("ชำระเงินแล้ว")) {
        cash = formik?.values?.cash?.replace("ชำระเงินแล้ว", "").trim();
      }
      formik.setValues({
        ...formik.values,
        paymentTerm: "",
        cash
      });
    }
  }, [formik?.values?.orderType]);

  useEffect(() => {
    if (shouldRecheckBlock) {
      formikItemDetails.setFieldValue(
        "lines",
        [INIT_EMPTY_ORDERLINE("10")],
        true
      );
      checkBlocks(newSoldToCode);
    }
  }, [shouldRecheckBlock]);

  const handleClear = data => {
    if (data === "") {
      if (formik?.values?.soldToCode && !isChangeFlow) {
        clearLocalOrderIds();
        navigate(getNotRefCreateOrderPath(""));
      }
      if (!isChangeFlow) {
        setOpts([]);
        const [
          salesOrganization,
          distributionChannel,
          division,
          salesOrganizationList,
          distributionChannelList,
          divisionList,
          defaultOtcSoldToCode,
          defaultOtcSoldToText
        ] = [
          formik?.values?.salesOrganizationCode,
          formik?.values?.distributionChannelCode,
          formik?.values?.divisionCode,
          formik?.values?.salesOrganizationList,
          formik?.values?.distributionChannelList,
          formik?.values?.divisionList,
          formik?.values?.defaultOtcSoldToCode,
          formik?.values?.defaultOtcSoldToText
        ];
        formik.resetForm();
        formikItemDetails.resetForm();
        formik.setValues({
          salesOrganizationCode: salesOrganization,
          distributionChannelCode: distributionChannel,
          divisionCode: division,
          salesOrganizationList,
          distributionChannelList,
          divisionList,
          defaultOtcSoldToCode,
          defaultOtcSoldToText,
          poDate: moment(new Date().toDateString()).format("YYYY-MM-DD")
        });
        safeHandleShowDetails(false);
      }
      setLoadHeaderData(false);
      safeHandleSoldTo("");
      setNewSoldToCode("");
    }
  };

  const handleSelectedSearch = (e: { value: string }) => {
    if (e.value) {
      const soldToCode = e.value;
      const id = getLocalOrderId(soldToCode);
      if (!orderId) {
        setNewSoldToCode(soldToCode);
        if (id && !isChangeFlow) {
          return fetchOrderData({
            variables: {
              orderId: id
            }
          });
        } else {
          checkBlocks(soldToCode);
        }
      }
    }
  };

  const handleOpenCreditMaster = () => {
    callCreditLimit({
      variables: {
        input: {
          salesOrgCode: formik.values?.salesOrganizationCode,
          soldToCode: formik.values?.soldToCode
        }
      }
    });
  };

  const checkBlocks = (soldToCode: string) => {
    setLoadHeaderData(false);
    getCustomerBlock({
      variables: {
        input: {
          soldToCode,
          saleOrganizationCode: formik?.values?.salesOrganizationCode ?? null
        }
      }
    });
    getCreditBlock({
      variables: {
        input: {
          salesOrgCode: formik?.values?.salesOrganizationCode,
          soldToCode
        }
      }
    });
  };

  const titlefields = [
    "name1",
    "street1",
    "street2",
    "subDistrict",
    "district",
    "city",
    "postalCode"
  ];
  const check = c => (c === "name1" ? "" : " ");
  const getAddressFormat = otc => {
    if (!otc) {
      return "";
    }
    return (
      (otc?.soldToCode ?? "") +
      " - " +
      titlefields.reduce((p, c) => p + (otc?.[c] ? check(c) + otc[c] : ""), "")
    );
  };

  const partnerDataMap = {
    paymentTermText: "Payment Term",
    taxClassDisplayText: "Tax Classification",
    poDate: "PO Date",
    requestDate: "Request Date",
    poNumber: " PO No. "
  };

  const viewFieldFormatter = (key, value) => {
    if (value && (key === "poDate" || key === "requestDate")) {
      return moment(value).format("DD/MM/YYYY");
    } else {
      return value;
    }
  };

  return (
    <div data-testid="notRefSalesPartnerForm">
      <Grid container spacing={6}>
        <Grid item xs={12} md={3} className={classes.brdRight}>
          <Grid item xs={12} md={6} lg={5} style={{ marginBottom: "10px" }}>
            <MyTypography variant={"h6"} className={classes.colorInfo}>
              {intl.formatMessage({ defaultMessage: "Sales" })}
            </MyTypography>
          </Grid>
          <Grid
            container
            spacing={3}
            alignItems={"center"}
            className={classes.gridRow}
          >
            <Grid item xs={12} className={classes.salesFieldWrap}>
              {!isViewMode
                ? formSalesData.map(
                    field =>
                      !field.isfieldVisibility && (
                        <FormField
                          gridStyle={{ alignSelf: "flex-end" }}
                          {...field}
                          value={formik.values[field.name]}
                          handleChange={formik.handleChange}
                          error={
                            formik.errors[field.name] &&
                            (salesDataloadingCompleted || isChangeFlow)
                          }
                          id={field.name}
                          data-testid={field.name}
                        />
                      )
                  )
                : formSalesData.map(
                    field =>
                      !field.isfieldVisibility && (
                        <div key={field.title}>
                          <MyTypography variant={"subtitle3"}>
                            {field.title}
                          </MyTypography>
                          <MyTypography
                            variant={"body3"}
                            className={`${classes.boxBackgroundChangeOrder} ${classes.margBot10}`}
                          >
                            {formik.values[field.name]}
                          </MyTypography>
                        </div>
                      )
                  )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={9}>
          <Grid
            item
            xs={12}
            md={9}
            className={classes.horzCenter}
            style={{ marginBottom: "10px" }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <MyTypography variant={"h6"} className={classes.colorInfo}>
                {isOneTimeCustomer
                  ? intl.formatMessage({ defaultMessage: "One-time Customer" })
                  : intl.formatMessage({ defaultMessage: "Partner" })}
              </MyTypography>
              {showDetails && !isOneTimeCustomer && (
                <Button
                  variant={"outlined"}
                  color={"secondary"}
                  className={classNames(classes.flexRight, classes.btnThin)}
                  onClick={handleOpenCreditMaster}
                  disabled={loadingCreditLimit}
                  id="creditMasterButton"
                  name="creditMasterButton"
                  data-testid="creditMasterButton"
                  startIcon={
                    <CreditCardIcon style={{ marginRight: 0, marginLeft: 4 }} />
                  }
                >
                  <MyTypography variant={"body3"}>
                    {intl.formatMessage({ defaultMessage: "Credit Master" })}
                  </MyTypography>
                </Button>
              )}
            </div>
            <ModalCreditMasterNotRef
              title="Credit Master"
              dataModal={dataCreditLimit?.getCreditLimit}
              open={openModalCreditMasterNotRef}
              onClose={() => setOpenModalCreditMasterNotRef(false)}
              soldToDisplayText={formik.values?.soldToDisplayText}
            />
          </Grid>
          <Grid item xs={12} md={9} className={classes.horzCenter}>
            {isOneTimeCustomer && (
              <>
                {!isViewMode && !isChangeFlow ? (
                  <>
                    <Grid item xs={12} md={12} style={{ marginBottom: "0px" }}>
                      <MyTypography variant={"subtitle3"}>
                        One-time Code<span className={classes.required}>*</span>
                      </MyTypography>
                    </Grid>
                    <Grid
                      container
                      spacing={2}
                      alignItems={"flex-start"}
                      className={classes.gridRow}
                    >
                      <Grid item xs={12} md={12}>
                        <SingleTextField
                          placeholder="ค้นหา One-time Code"
                          value={formik?.values?.soldToDisplayText}
                          onChange={() => null}
                          disabled
                          name="oneTimeCode"
                          id="oneTimeCode"
                          InputProps={{
                            inputProps: { "data-testid": "oneTimeCode-input" }
                          }}
                        />
                      </Grid>
                      {!showDetails && (
                        <Grid item xs={12} md={3}>
                          <Button
                            variant="contained"
                            className={classes.oneTimeBtn}
                            onClick={handleV}
                            disabled={false}
                            style={{ height: "37px" }}
                            id="oneTimeButton"
                            name="oneTimeButton"
                            data-testid="oneTimeButton"
                          >
                            {intl.formatMessage({
                              defaultMessage: "One-time Customer",
                              description: "button label"
                            })}
                          </Button>
                        </Grid>
                      )}
                    </Grid>{" "}
                  </>
                ) : (
                  <>
                    <Grid item xs={12} md={12} style={{ marginBottom: "0px" }}>
                      <MyTypography variant={"subtitle3"}>
                        One-time Code
                      </MyTypography>
                    </Grid>
                    <Grid
                      container
                      spacing={2}
                      alignItems={"flex-start"}
                      className={classes.gridRow}
                    >
                      <Grid item xs={12} md={12}>
                        <MyTypography
                          variant={"body3"}
                          className={classes.boxBackgroundChangeOrder}
                        >
                          {formik?.values?.soldToDisplayText}
                        </MyTypography>
                      </Grid>
                    </Grid>
                  </>
                )}
              </>
            )}
            {!isOneTimeCustomer && (
              <>
                {!isViewMode ? (
                  <>
                    <Grid item xs={12} md={12} style={{ marginBottom: "0px" }}>
                      {showDetails ? (
                        <MyTypography variant={"subtitle3"}>
                          Sold-to Party{/**/}
                          <span className={classes.required}>*</span>
                        </MyTypography>
                      ) : (
                        <MyTypography variant={"subtitle3"}>
                          Sold-to:
                        </MyTypography>
                      )}
                    </Grid>
                    <Grid
                      container
                      spacing={2}
                      alignItems={"flex-start"}
                      className={classes.gridRow}
                    >
                      <Grid item xs={12} md={showDetails ? 12 : 9}>
                        <SoldToInputSuggestion
                          searchField="search"
                          dataOptions={opts}
                          totalCount={opts.length}
                          loadingDataSuggestion={loadingDataSuggestionDemostic}
                          getDataSuggestions={getDataSuggestionsDemostic}
                          contained
                          name={"soldTo"}
                          id="soldTo"
                          defaultInputValue={formik?.values?.soldToCode}
                          defaultValue={{
                            title: formik?.values?.soldToDisplayText,
                            value: formik?.values?.soldToCode
                          }}
                          objectSuggestion
                          placeholder={"ค้นหา Sold-to Code / Name"}
                          handleSelectedSearch={handleSelectedSearch}
                          isDomestic
                          salesCode={formik?.values}
                          handleClear={handleClear}
                          disabled={
                            isChangeFlow || !(salesOrganizationList.length > 0)
                          }
                          saleOrgEmpty={
                            salesOrganizationList.length <= 0 && !saleOrgLoading
                          }
                          isChangeFlow={isChangeFlow}
                          isSearchIcon={!showDetails ? true : false}
                        />
                      </Grid>
                    </Grid>
                    {!showDetails && (
                      <Grid
                        item
                        xs={12}
                        md={12}
                        style={{ marginBottom: "0px" }}
                      >
                        <MyTypography variant={"subtitle3"}>
                          Create order by :
                        </MyTypography>
                      </Grid>
                    )}
                    {!showDetails && (
                      <Grid item xs={12} md={3}>
                        <Button
                          variant="contained"
                          className={classes.oneTimeBtn}
                          onClick={handleV}
                          disabled={!(salesOrganizationList.length > 0)}
                          style={{ height: "37px" }}
                          id="oneTimeCustomer"
                        >
                          {intl.formatMessage({
                            defaultMessage: "One-time Customer",
                            description: "button label"
                          })}
                        </Button>
                      </Grid>
                    )}
                    {!showDetails && (
                      <div style={{ marginTop: "10px" }}>
                        <MyTypography variant="body3">
                          {intl.formatMessage({
                            defaultMessage:
                              "กดปุ่ม “One-time Customer” เพื่อสร้างคำสั่งซื้อ"
                          })}
                        </MyTypography>
                      </div>
                    )}

                    {salesOrganizationList.length <= 0 &&
                      salesDataloadingCompleted && (
                        <div style={{ marginTop: "20px" }}>
                          <MyTypography variant="body3" color="error">
                            {intl.formatMessage({
                              defaultMessage:
                                "User has not been assigned a Sales Organization in the user management. Please contact system admin."
                            })}
                          </MyTypography>
                        </div>
                      )}
                  </>
                ) : (
                  <>
                    <Grid item xs={12} md={12} style={{ marginBottom: "0px" }}>
                      <MyTypography variant={"subtitle3"}>
                        Sold-to Party
                      </MyTypography>
                    </Grid>
                    <Grid
                      container
                      spacing={2}
                      alignItems={"flex-start"}
                      className={classes.gridRow}
                    >
                      <Grid item xs={12} md={12}>
                        <MyTypography
                          variant={"body3"}
                          className={classes.boxBackgroundChangeOrder}
                        >
                          {formik.values?.soldToDisplayText}
                        </MyTypography>
                      </Grid>
                    </Grid>
                  </>
                )}
              </>
            )}
          </Grid>
          <Grid item xs={12} md={9} className={classes.horzCenter}>
            <Grid
              container
              spacing={2}
              alignItems={"center"}
              className={classes.gridRow}
              data-testid="partnerDataForm"
            >
              {!isViewMode
                ? formPartnerData.map(
                    field =>
                      showDetails &&
                      (field.type === "Button" ? (
                        <Button
                          variant="contained"
                          className={classes.applyBtn}
                          onClick={onApplyAll}
                          disabled={applyAllButtonDisable}
                          style={{
                            margin: "0px 0px -17px 0px",
                            flexBasis: "15.5%",
                            maxWidth: "15.5%",
                            padding: 0,
                            height: "31px"
                          }}
                          id="applyAllButton"
                          name="applyAllButton"
                          data-testid="applyAllButton"
                        >
                          {intl.formatMessage({
                            defaultMessage: "Apply all",
                            description: "button label"
                          })}
                        </Button>
                      ) : (
                        <FormField
                          gridStyle={{ alignSelf: "flex-end" }}
                          {...field}
                          value={formik.values[field.name]}
                          handleChange={formik.handleChange}
                          error={formik.errors[field.name]}
                          id={field.name}
                          name={field.name}
                        />
                      ))
                  )
                : Object.keys(partnerDataMap).map(key => (
                    <div
                      key={key}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "4px",
                        alignSelf: "stretch",
                        flex: "0 0 calc(50% - 4px)",
                        maxWidth: "calc(50% - 4px)"
                      }}
                    >
                      <MyTypography
                        variant={"subtitle3"}
                        className={`${classes.rowFlex} ${classes.readOnlylabel}`}
                      >
                        {partnerDataMap[key]}
                      </MyTypography>
                      <MyTypography
                        variant={"body3"}
                        className={`${classes.boxBackgroundChangeOrder} ${classes.readOnlyField}`}
                      >
                        {viewFieldFormatter(key, formik.values[key])}
                      </MyTypography>
                    </div>
                  ))}
              <Grid item xs={12}>
                {showDetails || isViewMode ? (
                  <Grid item xs={12} md={12}>
                    {isOneTimeCustomer && (
                      <>
                        <div className={classes.rowFlex}>
                          <span
                            style={{ marginRight: "5px", fontWeight: "bold" }}
                          >
                            Sold-to Party
                          </span>
                          {!isChangeFlow && !isViewMode && (
                            <Button
                              variant={"outlined"}
                              color={"secondary"}
                              className={classNames(
                                classes.flexRight,
                                classes.btnThin
                              )}
                              onClick={() => handleV("soldTo")}
                              id="soldToButton"
                              name="soldToButton"
                              data-testid="soldToButton"
                            >
                              <MyTypography variant={"body3"}>
                                {intl.formatMessage({ defaultMessage: "Edit" })}
                              </MyTypography>
                            </Button>
                          )}
                        </div>
                        <MyTypography
                          variant={"subtitle3"}
                          className={classes.colorInfo}
                        >
                          {formik?.values?.soldToDisplayText}
                        </MyTypography>
                        <MyTypography
                          style={{
                            whiteSpace: "pre-line"
                          }}
                          variant={"body3"}
                          className={
                            isOneTimeCustomer
                              ? classes.marginBottom
                              : classes.rowContent
                          }
                        >
                          {getAddressFormat(formik?.values?.otcSoldTo)}
                        </MyTypography>
                        <MyTypography
                          variant={"body3"}
                          className={
                            isOneTimeCustomer
                              ? classes.marginBottom
                              : classes.rowContent
                          }
                        >
                          {formik?.values?.otcSoldTo?.countryName}
                        </MyTypography>
                        {!isViewMode ? (
                          <div className={classes.margBot20}>
                            <div className={classes.normalFlex}>
                              <div className={classes.margRight20}>
                                Tel:{" "}
                                {formik?.values?.otcSoldTo?.telephoneNo ||
                                  " - "}
                                &nbsp; Ext.{" "}
                                {formik?.values?.otcSoldTo
                                  ?.telephoneExtension || " - "}
                              </div>
                              <div>
                                <MyTypography variant="body3">
                                  Fax:{" "}
                                  {formik?.values?.otcSoldTo?.faxNo || "  -  "}
                                  &nbsp; Ext.{" "}
                                  {formik?.values?.otcSoldTo?.faxNoExt ||
                                    "  -  "}
                                </MyTypography>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className={classes.rowContent}>
                            <Grid container spacing={0}>
                              <Grid item xs={3}>
                                <MyTypography variant="body3">
                                  Tel:{" "}
                                  {formik?.values?.otcSoldTo?.telephoneNo
                                    ? formik?.values?.otcSoldTo?.telephoneNo
                                    : " - "}
                                  {"  "} Ext:{" "}
                                  {formik?.values?.otcSoldTo?.telephoneExtension
                                    ? formik?.values?.otcSoldTo
                                        ?.telephoneExtension
                                    : " - "}
                                </MyTypography>
                              </Grid>
                              <Grid item xs={3}>
                                <MyTypography variant="body3">
                                  Fax:{" "}
                                  {formik?.values?.otcSoldTo?.faxNo
                                    ? formik?.values?.otcSoldTo?.faxNo
                                    : "  -  "}
                                  {"  "} Ext:{" "}
                                  {formik?.values?.otcSoldTo?.faxNoExt
                                    ? formik?.values?.otcSoldTo?.faxNoExt
                                    : "  -  "}
                                </MyTypography>
                              </Grid>
                            </Grid>
                          </div>
                        )}
                      </>
                    )}
                    <div className={classes.rowFlex}>
                      <span style={{ marginRight: "5px", fontWeight: "bold" }}>
                        Bill-to Party
                      </span>
                      <MyTypography
                        variant={"subtitle3"}
                        className={classes.colorInfo}
                      >
                        {!isOneTimeCustomer &&
                          !isViewMode &&
                          `(${formik.values?.billTolist?.length || 0})`}
                      </MyTypography>
                      {((!isChangeFlow &&
                        !isOneTimeCustomer &&
                        formik.values?.billTolist?.length > 1) ||
                        (isChangeFlow && !isViewMode && !isOneTimeCustomer) ||
                        (!isChangeFlow && isOneTimeCustomer)) && (
                        <Button
                          variant={"outlined"}
                          color={"secondary"}
                          className={classNames(
                            classes.flexRight,
                            classes.btnThin
                          )}
                          onClick={() => handleVisible("billTo")}
                          id="editBillToButton"
                          name="editBillToButton"
                          data-testid="editBillToButton"
                        >
                          <MyTypography variant={"body3"}>
                            {intl.formatMessage({ defaultMessage: "Edit" })}
                          </MyTypography>
                        </Button>
                      )}
                    </div>
                    <MyTypography
                      variant={"body3"}
                      className={`${
                        isOneTimeCustomer
                          ? classes.marginBottom
                          : classes.rowContent
                      } ${classes.shipToLabel}`}
                      data-testid="billTo-text"
                    >
                      {isOneTimeCustomer
                        ? getAddressFormat(formik?.values?.otcBillTo)
                        : formik.values?.billTo}
                    </MyTypography>
                    {isOneTimeCustomer && (
                      <MyTypography
                        variant={"body3"}
                        className={
                          isOneTimeCustomer
                            ? classes.marginBottom
                            : classes.rowContent
                        }
                      >
                        {formik?.values?.otcBillTo?.countryName}
                      </MyTypography>
                    )}
                    {isOneTimeCustomer && (
                      <>
                        {isChangeFlow ? (
                          <div className={classes.marginBottom}>
                            <Grid container spacing={0}>
                              <Grid item xs={3}>
                                <MyTypography variant="body3">
                                  Tel:{" "}
                                  {formik?.values?.otcBillTo?.telephoneNo
                                    ? formik?.values?.otcBillTo?.telephoneNo
                                    : "  -  "}{" "}
                                  Ext:{" "}
                                  {formik?.values?.otcBillTo?.telephoneExtension
                                    ? formik?.values?.otcBillTo
                                        ?.telephoneExtension
                                    : "  -  "}{" "}
                                </MyTypography>
                              </Grid>
                              <Grid item xs={3}>
                                <MyTypography variant="body3">
                                  Fax:{" "}
                                  {formik?.values?.otcBillTo?.faxNo
                                    ? formik?.values?.otcBillTo?.faxNo
                                    : "  -  "}{" "}
                                  Ext:{" "}
                                  {formik?.values?.otcBillTo?.faxNoExt
                                    ? formik?.values?.otcBillTo?.faxNoExt
                                    : "  -  "}
                                </MyTypography>
                              </Grid>
                            </Grid>
                          </div>
                        ) : (
                          <div className={classes.normalFlex}>
                            <div className={classes.margRight20}>
                              <MyTypography variant="body3">
                                Tel:{" "}
                                {formik?.values?.otcBillTo?.telephoneNo ||
                                  " - "}
                                &nbsp; Ext.{" "}
                                {formik?.values?.otcBillTo
                                  ?.telephoneExtension || " - "}
                              </MyTypography>
                            </div>
                            <div>
                              <MyTypography variant="body3">
                                Fax: {formik?.values?.otcBillTo?.faxNo || " - "}
                                &nbsp; Ext.{" "}
                                {formik?.values?.otcBillTo?.faxNoExt || " - "}
                              </MyTypography>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {isOneTimeCustomer && (
                      <div>
                        <MyTypography
                          variant={"body3"}
                          className={
                            isOneTimeCustomer
                              ? classes.marginBottom
                              : classes.rowContent
                          }
                        >
                          Tax Number{" "}
                          {formik?.values?.otcBillTo?.countryCode === "TH"
                            ? 3
                            : 1}
                          :{" "}
                          <span className={classes.colorInfo}>
                            {formik?.values?.otcBillTo?.countryCode === "TH"
                              ? formik?.values?.otcBillTo?.taxId
                              : formik?.values?.otcBillTo?.taxNumber1}
                          </span>
                        </MyTypography>
                        <MyTypography
                          variant={"body3"}
                          className={classes.rowContent}
                        >
                          Tax Number{" "}
                          {formik?.values?.otcBillTo?.countryCode === "TH"
                            ? 4
                            : 2}
                          :{" "}
                          <span className={classes.colorInfo}>
                            {formik?.values?.otcBillTo?.countryCode === "TH"
                              ? formik?.values?.otcBillTo?.branchId
                              : formik?.values?.otcBillTo?.taxNumber2}
                          </span>
                        </MyTypography>
                      </div>
                    )}
                    <div className={classes.rowFlex}>
                      <span style={{ marginRight: "5px", fontWeight: "bold" }}>
                        Ship-to Party
                      </span>
                      <MyTypography
                        variant={"subtitle3"}
                        className={classes.colorInfo}
                      >
                        {!isOneTimeCustomer &&
                          !isViewMode &&
                          `(${formik.values?.shipTolist?.length || 0})`}
                      </MyTypography>
                      {!isViewMode && (
                        <Button
                          variant={"outlined"}
                          color={"secondary"}
                          className={classNames(
                            classes.flexRight,
                            classes.btnThin
                          )}
                          onClick={() => handleVisible("shipTo")}
                          id="editShipToButton"
                          name="editShipToButton"
                          data-testid="editShipToButton"
                        >
                          <MyTypography variant={"body3"}>
                            {intl.formatMessage({ defaultMessage: "Edit" })}
                          </MyTypography>
                        </Button>
                      )}
                    </div>
                    <MyTypography
                      className={`${
                        isOneTimeCustomer && formik?.values?.shipTo
                          ? classes.rowContent
                          : isOneTimeCustomer
                          ? classes.marginBottom
                          : classes.rowContent
                      } ${classes.shipToLabel}`}
                      variant={"body3"}
                      data-testid="shipTo-text"
                    >
                      {isOneTimeCustomer
                        ? formik?.values?.shipTo
                          ? formik?.values?.shipTo
                          : getAddressFormat(formik?.values?.otcShipTo)
                        : formik?.values?.shipTo}
                    </MyTypography>
                    {isOneTimeCustomer && !formik?.values?.shipTo && (
                      <MyTypography
                        variant={"body3"}
                        className={
                          isOneTimeCustomer
                            ? classes.marginBottom
                            : classes.rowContent
                        }
                      >
                        {formik?.values?.otcShipTo?.countryName}
                      </MyTypography>
                    )}
                    {isOneTimeCustomer && !formik?.values?.shipTo && (
                      <>
                        {isChangeFlow ? (
                          <div className={classes.marginBottom}>
                            <Grid container spacing={0}>
                              <Grid item xs={4}>
                                <MyTypography variant="body3">
                                  Tel:{" "}
                                  {formik?.values?.otcShipTo?.telephoneNo
                                    ? formik?.values?.otcShipTo?.telephoneNo
                                    : "  -  "}{" "}
                                  Ext:{" "}
                                  {formik?.values?.otcBillTo?.telephoneExtension
                                    ? formik?.values?.otcBillTo
                                        ?.telephoneExtension
                                    : "  -  "}{" "}
                                </MyTypography>
                              </Grid>
                              <Grid item xs={4}>
                                <MyTypography variant="body3">
                                  Fax:{" "}
                                  {formik?.values?.otcShipTo?.faxNo
                                    ? formik?.values?.otcShipTo?.faxNo
                                    : "  -  "}{" "}
                                  Ext:{" "}
                                  {formik?.values?.otcShipTo?.faxNoExt
                                    ? formik?.values?.otcShipTo?.faxNoExt
                                    : "  -  "}
                                </MyTypography>
                              </Grid>
                            </Grid>
                          </div>
                        ) : (
                          <div className={classes.normalFlex}>
                            <div className={classes.margRight20}>
                              <MyTypography variant="body3">
                                Tel:{" "}
                                {formik?.values?.otcShipTo?.telephoneNo ||
                                  " - "}
                                &nbsp; Ext.{" "}
                                {formik?.values?.otcShipTo
                                  ?.telephoneExtension || " - "}
                              </MyTypography>
                            </div>
                            <div>
                              <MyTypography variant="body3">
                                Fax: {formik?.values?.otcShipTo?.faxNo || " - "}
                                &nbsp; Ext.{" "}
                                {formik?.values?.otcShipTo?.faxNoExt || " - "}
                              </MyTypography>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {isOneTimeCustomer && !formik?.values?.shipTo && (
                      <div>
                        <MyTypography
                          variant={"body3"}
                          className={classes.rowContent}
                        >
                          Transportation Zone:{" "}
                          <span className={classes.colorInfo}>
                            {formik?.values?.otcShipTo?.transportZoneName}
                          </span>
                        </MyTypography>
                      </div>
                    )}
                    <div className={classes.rowFlex}>
                      <span style={{ marginRight: "5px", fontWeight: "bold" }}>
                        Unloading Point
                      </span>
                      <MyTypography
                        variant={"subtitle3"}
                        className={classes.colorInfo}
                      >
                        {!isOneTimeCustomer &&
                          !isViewMode &&
                          `(${formik.values?.unloadingPoints?.length || 0})`}
                      </MyTypography>
                      {!isViewMode &&
                        (formik?.values?.shipTo || !isOneTimeCustomer) && (
                          <>
                            <Button
                              variant={"outlined"}
                              color={"secondary"}
                              className={classNames(
                                classes.flexRight,
                                classes.btnThin
                              )}
                              onClick={handleVisibles}
                              id="editUnloadingPointButton"
                              name="editUnloadingPointButton"
                              data-testid="editUnloadingPointButton"
                            >
                              <MyTypography variant={"body3"}>
                                {intl.formatMessage({ defaultMessage: "Edit" })}
                              </MyTypography>
                            </Button>
                          </>
                        )}
                    </div>
                    <MyTypography
                      className={`${classes.rowContent} ${classes.shipToLabel}`}
                      variant={"body3"}
                      data-testid="unloadingPoint-text"
                    >
                      {isViewMode ? (
                        <>{formik?.values?.unloadingPoint}</>
                      ) : (
                        <>
                          {" "}
                          {isOneTimeCustomer &&
                          formik?.values?.otcShipTo &&
                          !formik?.values?.shipTo ? (
                            <Grid container spacing={0}>
                              <Grid item xs={12} md={12}>
                                <SingleTextField
                                  name="unloadingPoint"
                                  placeholder="พิมพ์ที่นี่"
                                  value={formik?.values?.unloadingPoint}
                                  onChange={formik?.handleChange}
                                  maxLengthProps={25}
                                  id="unloadingPoint"
                                />
                              </Grid>
                            </Grid>
                          ) : (
                            <>{formik?.values?.unloadingPoint}</>
                          )}
                          {!isOneTimeCustomer
                            ? formik?.values?.unloadingPoint?.unloadingPoint
                            : ""}
                        </>
                      )}
                    </MyTypography>
                  </Grid>
                ) : null}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <DialogCustomerBlock
        onConfirm={toggleModalCustomerBlock}
        open={openModalCustomerBlock}
        okText="ปิดหน้าต่าง"
        title="Customer Blocked"
        content={
          <>
            <img
              className={classes.iconModal}
              src={exclamationModal}
              alt="customer blocked"
            />
            <MyTypography variant="body2" className={classes.inlineBlock}>
              ไม่สามารถดำเนินการได้ เนื่องจากลูกค้ารายนี้ถูก{" "}
              <MyTypography variant="subtitle2" className={classes.inlineBlock}>
                Block{" "}
              </MyTypography>
              กรุณาติดต่อเจ้าหน้าที่สินเชื่อ
            </MyTypography>
          </>
        }
      />
      {shipToVisible && (
        <ModalAddress
          address={formik?.values?.shipTolist}
          initialValue={formik.values?.shipTo?.split("-")[0]?.trim()}
          visible={shipToVisible}
          onClose={() => {
            setShipToVisible(false);
          }}
          addressType="shipTo"
          formik={formik}
          handleSoldTo={safeHandleSoldTo}
          callShipToUnloading={callShipToUnloadingAndTax}
        />
      )}
      {billToVisible && (
        <ModalAddress
          address={formik.values?.billTolist}
          initialValue={formik.values?.billTo?.split("-")[0]?.trim()}
          visible={billToVisible}
          onClose={() => {
            setBillToVisible(false);
          }}
          addressType="billTo"
          formik={formik}
          handleSoldTo={safeHandleSoldTo}
          callShipToUnloading={callShipToUnloadingAndTax}
        />
      )}
      {soldToVisible && (
        <ModalAddress
          address={[]}
          initialValue={formik?.values?.soldToAddress?.split("-")[0]?.trim()}
          visible={soldToVisible}
          onClose={() => {
            setSoldToVisible(false);
          }}
          addressType="soldToAddress"
          formik={formik}
          handleSoldTo={safeHandleSoldTo}
          callShipToUnloading={callShipToUnloadingAndTax}
        />
      )}
      {visibless && (
        <ModalAddressOneTime
          address={null}
          visible={visibless}
          onClose={() => {
            if (formType === "soldTo") {
              setVisibless(false);
            } else {
              setVisibless(false);
              safeHandleShowDetails(false);
            }
          }}
          handleApplyAddress={null}
          handleShowDetails={safeHandleShowDetails}
          onOpen={() => {
            setVisibless(true);
          }}
          defaultAddress=""
          formik={formik}
          formType={formType}
        />
      )}
      {visibles && (
        <ModalAddressUnloading
          address={formik.values?.unloadingPoints}
          visible={visibles}
          onClose={() => {
            setVisibles(false);
          }}
          formik={formik}
        />
      )}
      {modalOneTimeFormVisible && (
        <ModalOneTimeForms
          visible={modalOneTimeFormVisible}
          onClose={() => {
            setModalOneTimeFormVisible(false);
          }}
          formType={formType}
          formikHeader={formik}
          onSearchSubmit={(name, Deletename, value) => {
            formik.setFieldValue(name, value);
            formik.setFieldValue(Deletename, null);
            callShipToUnloadingAndTax({
              variables: {
                shipTo: value?.split("-")[0],
                saleOrg: formik?.values?.salesOrganizationCode,
                distributionChannel: formik?.values?.distributionChannelCode,
                division: formik?.values?.divisionCode
              }
            });
          }}
          onSubmit={(name, Deletename, otc) => {
            formik.setFieldValue(name, otc);
            formik.setFieldValue(Deletename, null);
          }}
          otcInitialValue={
            formType === "shipTo"
              ? formik.values?.otcShipTo
              : formik.values?.otcBillTo
          }
          searchInitialValue={
            formType === "shipTo" ? formik.values?.shipTo : null
          }
          isChangeFlow={isChangeFlow}
        />
      )}
      <DialogCreditBlock
        onConfirm={toggleModalCreditBlock}
        open={openModalCreditBlock}
        okText="ปิดหน้าต่าง"
        title="Credit Blocked"
        content={
          <>
            <img
              className={classes.iconModal}
              src={exclamationModal}
              alt="customer blocked"
            />
            <MyTypography variant="body2" className={classes.inlineBlock}>
              ไม่สามารถทำรายการได้ เนื่องจากลูกค้าติด{" "}
              <MyTypography variant="subtitle2" className={classes.inlineBlock}>
                Credit Blocked
              </MyTypography>{" "}
              กรุณาติดต่อเจ้าหน้าที่สินเชื่อ
            </MyTypography>
          </>
        }
      />
    </div>
  );
};

export default NotRefSalesPartnerForm;
